let conditionIndex = 0;

export const getConditionIndex = () => (conditionIndex++);